import React from 'react';
import { func, string, arrayOf } from 'prop-types';
import { Field } from 'redux-form';

import RenderAddButton from 'components/Forms/ReduxFormFields/AddButton/RenderAddButton';

const addButtonFormFieldDefaultPropValidate = [];
const addButtonFormFieldDefaultPropOnClick = () => {};

const AddButtonFormField = ({
  validate = addButtonFormFieldDefaultPropValidate,
  label = '',
  onClick = addButtonFormFieldDefaultPropOnClick,
  name = 'add-button',
  id = 'add-button',
  ...rest
}) => {
  return (
    <Field
      component={RenderAddButton}
      validate={validate}
      label={label}
      onClick={onClick}
      name={name}
      id={id}
      {...rest}
    />
  );
};

AddButtonFormField.propTypes = {
  validate: arrayOf(func),
  label: string,
  onClick: func,
  name: string,
  id: string,
};

export default AddButtonFormField;
